module.exports = {
  Accelerometer : {},
  Gyroscope : {},
}



// WEBPACK FOOTER //
// ./src/wrappers/react-native-sensors-wrapper.js